var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightRamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1031,
    height: 496,
    viewBox: "0 0 1031 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1030.73 167.587L413.732 248.725L682.73 295.727L1030.73 167.587Z",
    fill: "#BA1610"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M643.5 424.412L414.999 322.913L415 251.91L679.501 300.911L643.5 424.412Z",
    fill: "#BA1610"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1018 208.5L645.388 423.568L682.889 301.067L1026 172L1018 208.5Z",
    fill: "#EC2D27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M410.665 321.91L251.164 266.91L241.164 222.913L410.665 250.413L410.665 290.779L410.665 321.91Z",
    fill: "#BA1610"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.502 258.912L162.002 238.412L133.5 211.91L237.5 222.911L247.502 265.412L227.502 258.912Z",
    fill: "#BA1610"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5001 220.894L42 211.412L11.9997 196.91L129.5 211.412L157.5 237.91L90.5001 220.894Z",
    fill: "#BA1610"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.5 168.501L243.494 220.912L408.657 244.055L1014.5 168.501Z",
    fill: "#D2312C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313.497 185.914L136.496 209.91L238.497 219.914L877 175.5L313.497 185.914Z",
    fill: "#D2312C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8291 183.224L0.000744665 194.955L131 208.91L306.999 183.221L86.8291 183.224Z",
    fill: "#D2312C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRamp);
export default __webpack_public_path__ + "static/media/right_ramp.d561d3c3e30d534e84e1af9852d98c64.svg";
export { ForwardRef as ReactComponent };